export { Card as UpdateBigcommerceConfigurationCard } from './card'
